export class UrlBuilder {
    private readonly baseUrl: string;

    constructor(baseUrl: string, basePath?: string) {
        const normalizedBase = this.trimSlashesEnd(baseUrl);

        if (basePath && basePath.trim().length > 0) {
            const normalizedBasePath = this.trimSlashes(basePath);
            this.baseUrl = `${normalizedBase}/${normalizedBasePath}`;
            return;
        }

        this.baseUrl = normalizedBase;
    }

    public build(path?: string | number, queryParams?: Record<string, string | number | boolean | null | undefined>): string {
        return this.builds(queryParams, path);
    }

    public builds(
        queryParams?: Record<string, string | number | boolean | null | undefined>,
        ...paths: Array<string | number | null | undefined>
    ): string {
        let url = this.baseUrl;

        for (const path of paths) {
            if (path === undefined || path === null || String(path).trim().length === 0) {
                continue;
            }

            url += `/${this.trimSlashes(String(path))}`;
        }

        const params = this.paramsToString(queryParams);
        return params ? `${url}${params}` : url;
    }

    private resolveBuildArgs(args: readonly unknown[]): {
        readonly paths: Array<string | number | null | undefined>;
        readonly queryParams?: Record<string, string | number | boolean | null | undefined>;
    } {
        const lastArg = args.at(-1);

        if (this.isQueryParams(lastArg)) {
            return {
                paths: args.slice(0, -1) as Array<string | number | null | undefined>,
                queryParams: lastArg,
            };
        }

        return {
            paths: args as Array<string | number | null | undefined>,
        };
    }

    private isQueryParams(value: unknown): value is Record<string, string | number | boolean | null | undefined> {
        return typeof value === 'object' && value !== null && !Array.isArray(value);
    }

    private paramsToString(
        params?: Record<string, string | number | boolean | null | undefined>
    ): string {
        if (!params) {
            return '';
        }

        const entries = Object.entries(params)
            .filter(([, value]) => value !== undefined && value !== null);

        if (entries.length === 0) {
            return '';
        }

        const query = entries
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
            .join('&');

        return `?${query}`;
    }

    private trimSlashes(value: string): string {
        return value.replace(/^\/+|\/+$/g, '');
    }

    private trimSlashesEnd(value: string): string {
        return value.replace(/\/+$/g, '');
    }
}
